import React, { useState, useEffect } from 'react';
import t0 from '../assets/testimonial/t0.webp';
import t1 from '../assets/testimonial/t1.webp';
import t2 from '../assets/testimonial/t2.webp';
import t3 from '../assets/testimonial/t3.webp';
import t4 from '../assets/testimonial/t4.webp';
import t5 from '../assets/testimonial/t5.webp';

const testimonials = [
  {
    id: 0,
    name: "Happy Family",
    text: "The whole family matched in our tartans — even the little ones. Couldn't have asked for a more special day.",
    image: t0,
    role: "Family Order"
  },
  {
    id: 1,
    name: "James MacGregor",
    text: "The quality of the kilt is outstanding. It fits perfectly and the tartan is exactly what I wanted. Truly a masterpiece of craftsmanship.",
    image: t1,
    role: "Verified Buyer"
  },
  {
    id: 2,
    name: "Sarah Wallace",
    text: "I absolutely love my Diana scarf and tartan skirt. The fabric is so soft and the colors are vibrant. I wear them everywhere!",
    image: t2,
    role: "Verified Buyer"
  },
  {
    id: 3,
    name: "The Highland Lads",
    text: "We all bought our kilts together for our annual gathering. The team looked after us brilliantly. Best decision we've made!",
    image: t3,
    role: "Group Purchase"
  },
  {
    id: 4,
    name: "Calum Campbell",
    text: "Our wedding day was perfect, and the kilt was the icing on the cake. It looked amazing in the photos and felt great to wear.",
    image: t4,
    role: "Wedding Groom"
  },
  {
    id: 5,
    name: "David Ross",
    text: "Worth every penny. I've worn it to several events now and always get compliments. It's comfortable and looks majestic.",
    image: t5,
    role: "Clan Member"
  }
];

const TestimonialCarouselNew = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe || isRightSwipe) {
      if (isLeftSwipe) nextSlide();
      else prevSlide();
    }
  };

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isPaused]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div 
      className="relative w-full max-w-[1400px] mx-auto px-4 py-4"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* Main Carousel Container */}
      <div className="relative h-[600px] md:h-[400px] flex items-center justify-center perspective-1000">
        {testimonials.map((testimonial, index) => {
           // Calculate position relative to current index
           let position = index - currentIndex;
           if (position < -2) position += testimonials.length;
           if (position > 2) position -= testimonials.length;
           
           // Determine styles based on position
           const isCenter = position === 0;
           const isLeft = position === -1;
           const isRight = position === 1;
           const isVisible = isCenter || isLeft || isRight;

           let transformClass = '';
           let zIndex = 0;
           let opacity = 0;
           
           if (isCenter) {
             transformClass = 'translate-x-0 scale-100';
             zIndex = 30;
             opacity = 1;
           } else if (isLeft) {
             transformClass = '-translate-x-[60%] scale-90';
             zIndex = 20;
             opacity = 0.3;
           } else if (isRight) {
             transformClass = 'translate-x-[60%] scale-90';
             zIndex = 20;
             opacity = 0.3;
           } else {
             transformClass = 'scale-75 opacity-0';
             zIndex = 10;
           }

           if (!isVisible) return null;

           return (
            <div 
              key={testimonial.id}
              className={`absolute top-1/2 left-1/2 -translate-y-1/2 w-[90%] md:w-[60%] max-w-3xl transition-all duration-700 ease-out -ml-[45%] md:-ml-[30%] ${transformClass}`}
              style={{ 
                zIndex, 
                opacity
              }}
            >
              {/* Card Content */}
              <div className={`bg-white/90 backdrop-blur-md border border-stone-200 rounded-3xl p-6 md:p-12 shadow-2xl flex flex-col md:flex-row items-center gap-6 md:gap-12 ${isCenter ? 'shadow-primary/10 ring-1 ring-primary/20' : 'grayscale-[50%]'}`}>
                
                {/* Image Section */}
                <div className="w-48 h-64 md:w-64 md:h-80 flex-shrink-0 relative">
                  <div className="absolute inset-0 bg-gradient-to-tr from-primary to-secondary rounded-2xl opacity-10 blur-lg"></div>
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name} 
                    className="w-full h-full object-cover rounded-2xl border border-stone-100 shadow-lg relative z-10 transition-all duration-500"
                  />
                </div>

                {/* Text Section */}
                <div className="flex-1 text-center md:text-left">
                  <blockquote className="text-base md:text-xl text-gray-800 italic font-serif mb-6 md:mb-8 leading-relaxed">
                    "{testimonial.text}"
                  </blockquote>
                  <div>
                    <h4 className="text-2xl font-serif font-bold text-primary mb-2">{testimonial.name}</h4>
                    <p className="text-gray-500 text-sm uppercase tracking-widest font-semibold">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Navigation Buttons */}
      <button 
        onClick={prevSlide}
        className="absolute left-4 md:left-12 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-primary text-gray-800 hover:text-white p-4 rounded-full transition-all duration-300 backdrop-blur-md border border-stone-200 shadow-lg z-40 group hidden md:block"
        aria-label="Previous testimonial"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6 group-hover:-translate-x-1 transition-transform">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>
      
      <button 
        onClick={nextSlide}
        className="absolute right-4 md:right-12 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-primary text-gray-800 hover:text-white p-4 rounded-full transition-all duration-300 backdrop-blur-md border border-stone-200 shadow-lg z-40 group hidden md:block"
        aria-label="Next testimonial"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6 group-hover:translate-x-1 transition-transform">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </button>

      {/* Pagination Dots */}
      <div className="flex justify-center gap-3 mt-8 relative z-40">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              currentIndex === index ? 'w-8 bg-primary' : 'w-2 bg-stone-300 hover:bg-stone-400'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialCarouselNew;
